import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import Cookies from 'yoda-core-components/lib/helpers/Cookies/Cookies';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import config from './ExitPos.config';

const csc = 'csc';
const findmore = 'findmore';

const findAppKeyFromCookieValue = (cookieConfigValues = {}, cookieValue = null) => {
    let appKey = null;
    const configKeys = Object.keys(cookieConfigValues);

    configKeys.forEach((cookieKey) => {
        if (appKey) {
            return;
        }

        if (cookieKey && cookieConfigValues[cookieKey].indexOf(cookieValue) !== -1) {
            appKey = cookieKey;
        }
    });
    return appKey;
};

export class ExitPos extends PureComponent {
    static defaultProps = {
        preferences: {},
    };

    static propTypes = {
        preferences: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    };

    constructor(props) {
        super(props);
        this.state = {
            posTitle: '',
        };
    }

    componentWillMount() {
        if (!__SERVER__) {
            const pref = this.props.preferences;
            const cookieName = pref.cookieName || 'Fusion-Platform';
            let appMode = Cookies.load(cookieName) || '';
            appMode = appMode.toLowerCase();
            appMode = findAppKeyFromCookieValue(pref.cookieConfigValues, appMode);
            if (appMode && appMode in pref) {
                this.setState({
                    posTitle: pref[appMode].content,
                    appMode,
                });
            }
        }
    }

    goExitPosClick = () => {
        window.localStorage.clear();
        window.sessionStorage.clear();
        Cookies.clearAll();

        /* istanbul ignore next */
        if (this.state.appMode === csc) {
            window.location.href = this.props.preferences[csc].link;
        } else {
            window.postMessage(this.props.preferences[findmore].message, '*');
        }
    };

    render() {
        return (
            <div className={`${dt(['inline-block', 'align-middle'])} ${'exitPos'}`}>
                <button
                    className={`${dt(['text-normal', 'text-white'])} ${'clsExitPosBtn'}`}
                    data-itemid="exitPos"
                    buttonType="Primary"
                    size="Lg"
                    onClick={this.goExitPosClick}
                    data-title="MENU"
                    data-name={this.state.posTitle}
                    data-nid="exitPos"
                >
                    {this.state.posTitle}
                </button>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const { context } = state;
    const preferences =
        context && context.preferences && context.preferences.ExitPos
            ? context.preferences.ExitPos
            : config;

    return {
        preferences,
    };
};

export default connect(mapStateToProps)(ExitPos);
